/* tslint:disable */
/* eslint-disable */
/**
 * Leads API
 * API for managing leads (potential customers from external sources)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadExterneListItemDto } from './LeadExterneListItemDto';
import {
    LeadExterneListItemDtoFromJSON,
    LeadExterneListItemDtoFromJSONTyped,
    LeadExterneListItemDtoToJSON,
    LeadExterneListItemDtoToJSONTyped,
} from './LeadExterneListItemDto';

/**
 * Réponse paginée de la liste des leads externes
 * @export
 * @interface SearchLeadsExternesResponse
 */
export interface SearchLeadsExternesResponse {
    /**
     * 
     * @type {Array<LeadExterneListItemDto>}
     * @memberof SearchLeadsExternesResponse
     */
    items: Array<LeadExterneListItemDto>;
    /**
     * 
     * @type {number}
     * @memberof SearchLeadsExternesResponse
     */
    totalCount: number;
}

/**
 * Check if a given object implements the SearchLeadsExternesResponse interface.
 */
export function instanceOfSearchLeadsExternesResponse(value: object): value is SearchLeadsExternesResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    return true;
}

export function SearchLeadsExternesResponseFromJSON(json: any): SearchLeadsExternesResponse {
    return SearchLeadsExternesResponseFromJSONTyped(json, false);
}

export function SearchLeadsExternesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchLeadsExternesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(LeadExterneListItemDtoFromJSON)),
        'totalCount': json['totalCount'],
    };
}

export function SearchLeadsExternesResponseToJSON(json: any): SearchLeadsExternesResponse {
    return SearchLeadsExternesResponseToJSONTyped(json, false);
}

export function SearchLeadsExternesResponseToJSONTyped(value?: SearchLeadsExternesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(LeadExterneListItemDtoToJSON)),
        'totalCount': value['totalCount'],
    };
}

